var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-field form-input"},[_c('q-input',{staticClass:"float-field",attrs:{"filled":"","no-error-icon":"","value":_vm.value,"type":"number","min":"0","step":"any","label-slot":false},on:{"input":function($event){return _vm.onChange(_vm.item, $event)},"clear":function($event){return _vm.onChange(_vm.item, $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }